import React from "react";

export default function ShareICirclecon() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_b_58_4678)">
        <rect width="32" height="32" rx="16" fill="white" fillOpacity="0.92" />
        <rect
          x="0.5"
          y="0.5"
          width="31"
          height="31"
          rx="15.5"
          stroke="#FFE500"
        />
        <mask
          id="mask0_58_4678"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="8"
          y="8"
          width="16"
          height="16"
        >
          <rect x="8" y="8" width="16" height="16" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_58_4678)">
          <path
            d="M19.335 22.6665C18.7794 22.6665 18.3072 22.472 17.9183 22.0831C17.5294 21.6942 17.335 21.222 17.335 20.6665C17.335 20.5998 17.3516 20.4442 17.385 20.1998L12.7016 17.4665C12.5238 17.6331 12.3183 17.7637 12.085 17.8581C11.8516 17.9526 11.6016 17.9998 11.335 17.9998C10.7794 17.9998 10.3072 17.8054 9.91829 17.4165C9.52941 17.0276 9.33496 16.5554 9.33496 15.9998C9.33496 15.4442 9.52941 14.972 9.91829 14.5831C10.3072 14.1942 10.7794 13.9998 11.335 13.9998C11.6016 13.9998 11.8516 14.047 12.085 14.1415C12.3183 14.2359 12.5238 14.3665 12.7016 14.5331L17.385 11.7998C17.3627 11.722 17.3489 11.647 17.3433 11.5748C17.3377 11.5026 17.335 11.422 17.335 11.3331C17.335 10.7776 17.5294 10.3054 17.9183 9.91646C18.3072 9.52757 18.7794 9.33313 19.335 9.33313C19.8905 9.33313 20.3627 9.52757 20.7516 9.91646C21.1405 10.3054 21.335 10.7776 21.335 11.3331C21.335 11.8887 21.1405 12.3609 20.7516 12.7498C20.3627 13.1387 19.8905 13.3331 19.335 13.3331C19.0683 13.3331 18.8183 13.2859 18.585 13.1915C18.3516 13.097 18.1461 12.9665 17.9683 12.7998L13.285 15.5331C13.3072 15.6109 13.3211 15.6859 13.3266 15.7581C13.3322 15.8304 13.335 15.9109 13.335 15.9998C13.335 16.0887 13.3322 16.1692 13.3266 16.2415C13.3211 16.3137 13.3072 16.3887 13.285 16.4665L17.9683 19.1998C18.1461 19.0331 18.3516 18.9026 18.585 18.8081C18.8183 18.7137 19.0683 18.6665 19.335 18.6665C19.8905 18.6665 20.3627 18.8609 20.7516 19.2498C21.1405 19.6387 21.335 20.1109 21.335 20.6665C21.335 21.222 21.1405 21.6942 20.7516 22.0831C20.3627 22.472 19.8905 22.6665 19.335 22.6665ZM19.335 21.3331C19.5239 21.3331 19.6822 21.2692 19.81 21.1415C19.9377 21.0137 20.0016 20.8554 20.0016 20.6665C20.0016 20.4776 19.9377 20.3192 19.81 20.1915C19.6822 20.0637 19.5239 19.9998 19.335 19.9998C19.1461 19.9998 18.9877 20.0637 18.86 20.1915C18.7322 20.3192 18.6683 20.4776 18.6683 20.6665C18.6683 20.8554 18.7322 21.0137 18.86 21.1415C18.9877 21.2692 19.1461 21.3331 19.335 21.3331ZM11.335 16.6665C11.5238 16.6665 11.6822 16.6026 11.81 16.4748C11.9377 16.347 12.0016 16.1887 12.0016 15.9998C12.0016 15.8109 11.9377 15.6526 11.81 15.5248C11.6822 15.397 11.5238 15.3331 11.335 15.3331C11.1461 15.3331 10.9877 15.397 10.86 15.5248C10.7322 15.6526 10.6683 15.8109 10.6683 15.9998C10.6683 16.1887 10.7322 16.347 10.86 16.4748C10.9877 16.6026 11.1461 16.6665 11.335 16.6665ZM19.335 11.9998C19.5239 11.9998 19.6822 11.9359 19.81 11.8081C19.9377 11.6804 20.0016 11.522 20.0016 11.3331C20.0016 11.1442 19.9377 10.9859 19.81 10.8581C19.6822 10.7304 19.5239 10.6665 19.335 10.6665C19.1461 10.6665 18.9877 10.7304 18.86 10.8581C18.7322 10.9859 18.6683 11.1442 18.6683 11.3331C18.6683 11.522 18.7322 11.6804 18.86 11.8081C18.9877 11.9359 19.1461 11.9998 19.335 11.9998Z"
            fill="#3C3C3C"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_b_58_4678"
          x="-12"
          y="-12"
          width="56"
          height="56"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="6" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_58_4678"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_58_4678"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}
